
import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Link } from "react-router-dom";

const sampleWebtoons = [
  {
    id: 1,
    title: "The Beginning After The End",
    cover: "/lovable-uploads/b146e022-1fe8-40a4-861a-db11d4d1bc90.png",
    author: "TurtleMe",
    genre: "Fantasy",
  },
  {
    id: 2,
    title: "Solo Leveling",
    cover: "/lovable-uploads/58fb91ea-8e3f-4b08-a768-08c041caa5d5.png",
    author: "Dubu (Redice Studio)",
    genre: "Action",
  },
  {
    id: 3,
    title: "Tower of God",
    cover: "/lovable-uploads/c577f9da-620e-45e7-8bb9-1c7314b7862e.png",
    author: "SIU",
    genre: "Fantasy",
  },
  {
    id: 4,
    title: "Omniscient Reader",
    cover: "/lovable-uploads/fcd141f3-253f-40e3-ba9a-70b47b49d47f.png",
    author: "sing N song",
    genre: "Action",
  },
];

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { 
    opacity: 1,
    transition: { 
      staggerChildren: 0.1
    } 
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5 }
  }
};

export const WebToonsGrid = () => {
  return (
    <motion.div 
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {sampleWebtoons.map((webtoon) => (
        <motion.div 
          key={webtoon.id}
          variants={itemVariants}
          whileHover={{ 
            scale: 1.05, 
            boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.15)",
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.98 }}
        >
          <Link
            to={`/webtoon/${webtoon.id}`}
            className="group relative aspect-[3/4] rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 block"
          >
            <img
              src={webtoon.cover}
              alt={webtoon.title}
              className="w-full h-full object-cover"
            />
            <motion.div 
              className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"
              initial={{ opacity: 0 }}
              whileHover={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
            >
              <motion.div 
                className="absolute bottom-0 left-0 right-0 p-4 text-white"
                initial={{ y: 20, opacity: 0 }}
                whileHover={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.3, delay: 0.1 }}
              >
                <h3 className="font-bold text-lg">{webtoon.title}</h3>
                <p className="text-sm opacity-80">{webtoon.author}</p>
                <motion.span 
                  className="inline-block mt-2 px-2 py-1 bg-primary/20 rounded-full text-xs"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileHover={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.2, delay: 0.2 }}
                >
                  {webtoon.genre}
                </motion.span>
              </motion.div>
            </motion.div>
          </Link>
        </motion.div>
      ))}
    </motion.div>
  );
};
